import styled, { css } from "styled-components";
import CheckSvg from "assets/icons/check-white.svg";

export const SecessionContainer = styled.section`
  height: 100%;
  position: relative;
  top: 0;
  left: 0;
  padding: 0 16px;
`;

const boxTitle = css`
  margin-top: 40px;

  > h2 {
    font-weight: 700;
    font-size: 20px;
  }
`;

export const SecessionNotice = styled.div`
  ${boxTitle}

  .notice-box {
    padding: 20px 16px;
    border-radius: 8px;
    background-color: #f1f3f5;
    margin-top: 16px;

    .notice-info {
      display: flex;
      align-items: flex-start;

      :not(:last-child) {
        margin-bottom: 12px;
      }
    }

    p {
      font-weight: 400;
      font-size: 12px;
      color: #4a5056;
      margin-left: 2px;
    }
  }

  .notice-agree-box {
    margin-top: 16px;

    label {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
    }

    input[type="checkbox"] {
      width: 20px;
      height: 20px;
      border: 1px solid #dfe2e6;
      border-radius: 4px;
      cursor: pointer;
      margin-right: 8px;

      &:checked {
        background: #ff7a00 url(${CheckSvg}) 50% 50% no-repeat;
        background-color: #ff7a00;
        border: none;
      }
    }
  }
`;
export const SecessionReason = styled.div`
  ${boxTitle}

  .reason-box {
    display: flex;
    align-items: center;
    padding: 16px 12px;
    font-size: 14px;
  }

  input[type="radio"] {
    width: 20%;
    width: 20px !important;
    height: 20px !important;
    border: 1px solid #dfe2e6;
    border-radius: 4px;
    cursor: pointer;
    margin-right: 8px;
    &:checked {
      background: #ff7a00 url(${CheckSvg}) 50% 50% no-repeat;
      background-color: #ff7a00;
      border: 1px solid #ff7a00;
    }

    &:disabled {
      background-color: #c3c3c3;
    }
  }

  label {
    width: 80%;
  }
`;

export const SecessionButton = styled.button`
  width: 100%;
  height: 56px;
  padding: 16px 0;
  position: fixed;
  z-index: 1;
  bottom: 0;
  left: 0;
  background-color: #ff7a00;
  border: none;
  color: #ffffff;
  font-weight: 700;
  cursor: pointer;
`;
